const STYLE_BREAKPOINTS = {
	forPhoneOnly: window.matchMedia("(max-width: 599px)"),
	forTabletPortraitUp: window.matchMedia("(min-width: 600px)"),
	forTabletLandscapeUp: window.matchMedia("(min-width: 900px)"),
	forDesktopUp: window.matchMedia("(min-width: 1200px)"),
	forBigDesktopUp: window.matchMedia("(min-width: 1800px)")
};

const CHART_COLORS = {
    lightGreen :'rgb(146,208,80)',
    green : 'rgb(0,176,80)',
    blue : 'rgb(78,103,200)',
    lightBlue : 'rgb(94,204,243)',
    orange : 'rgb(255,128,33)',
    red : 'rgb(241,65,36)',
    yellow : 'rgb(255,192,0)',
    darkBlue : 'rgb(33,48,106)',
	lilac : 'rgb(112,48,160)',
	darkRed : 'rgb(130,26,8)',
};

const X_AXIS_VAR = 'TimeSpanOffset';